import { Resource } from "../../../../../types";

interface ResourcesProps {
  resources: Resource[];
  onResourceToggle: (resource: string) => void;
}

const Resources = ({ resources = [], onResourceToggle }: ResourcesProps) => {
  return (
    <div className="w-full">
      <h5 className="mb-2 text-2xl font-bold">Resources and Tools</h5>
      <div className="space-y-2">
        {resources.map((resource) => (
          <div className="flex items-center" key={resource.name}>
          <div 
            onClick={() => onResourceToggle(resource.name)}
            className={`bg-white p-3 rounded shadow-sm cursor-pointer border-2 ${
              resource.checked ? 'border-4 border-yellow-500' : 'border-l-4 border-l-yellow-400'
            }`}
          >
              <strong>{resource.type}:</strong> {resource.name}
            </div>
          </div>
        ))}
      </div>
      <button className="bg-blue-500 text-white px-4 py-2 rounded-md mt-3">
        Send
      </button>
    </div>
  );
};

export default Resources;
